const CFG = (() => { try { return JSON.parse(document.getElementById("mw-config")?.textContent || "{}"); } catch (e) { return {}; } })();
const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches || (navigator.hardwareConcurrency || 4) <= 4 || (navigator.deviceMemory || 4) <= 2;
function toast(msg) {
let t = document.querySelector(".mw-toast");
if (!t) { t = document.createElement("div"); t.className = "mw-toast"; t.setAttribute("role", "status"); document.body.appendChild(t); }
t.textContent = msg; t.classList.add("is-on");
clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove("is-on"), 3600);
}
const FIRE = (() => {
const mk = (stops) => {
const c = document.createElement("canvas"); c.width = c.height = 64;
const g = c.getContext("2d"), gr = g.createRadialGradient(32, 32, 0, 32, 32, 32);
stops.forEach(([o, col]) => gr.addColorStop(o, col)); g.fillStyle = gr; g.fillRect(0, 0, 64, 64);
return c;
};
const sprites = [
mk([[0, "rgba(255,250,220,1)"], [.25, "rgba(255,214,120,.9)"], [1, "rgba(255,140,40,0)"]]),
mk([[0, "rgba(255,200,90,1)"], [.3, "rgba(255,110,30,.8)"], [1, "rgba(230,50,20,0)"]]),
mk([[0, "rgba(255,90,40,.9)"], [.35, "rgba(216,38,44,.6)"], [1, "rgba(120,10,10,0)"]])
];
const pick = (k) => sprites[k < .25 ? 0 : k < .55 ? 1 : 2];
const draw = (g, p) => {
const k = p.age / p.life, s = p.size * (1 - k * .5);
g.globalAlpha = Math.max(0, 1 - k);
g.drawImage(pick(k), p.x - s / 2, p.y - s / 2, s, s);
};
return { sprites, pick, draw };
})();
const fx = (() => {
let cv, g, parts = [], emitters = [], running = false, dpr = 1;
const resize = () => { dpr = Math.min(devicePixelRatio, 2); cv.width = innerWidth * dpr; cv.height = innerHeight * dpr; };
const ensure = () => {
if (cv) return;
cv = document.createElement("canvas"); cv.className = "mw-fx"; cv.setAttribute("aria-hidden", "true");
document.body.appendChild(cv); g = cv.getContext("2d"); resize(); addEventListener("resize", resize);
};
const spawn = (x, y, n, spread = 1, up = 1) => {
for (let i = 0; i < n; i++) {
const a = Math.random() * Math.PI * 2, sp = (Math.random() * 2.4 + .6) * spread;
parts.push({ x, y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp * .6 - (Math.random() * 2.5 + 1) * up, life: 30 + Math.random() * 30, age: 0, size: 10 + Math.random() * 22 });
}
};
const loop = (now) => {
g.setTransform(dpr, 0, 0, dpr, 0, 0); g.clearRect(0, 0, innerWidth, innerHeight);
g.globalCompositeOperation = "lighter";
emitters = emitters.filter((e) => e(now) !== false);
parts = parts.filter((p) => {
p.age++; p.x += p.vx; p.y += p.vy; p.vx = p.vx * .96 + (Math.random() - .5) * .3; p.vy = p.vy * .96 - .06;
if (p.age >= p.life) return false;
FIRE.draw(g, p); return true;
});
g.globalAlpha = 1;
if (parts.length || emitters.length) requestAnimationFrame(loop);
else { running = false; g.clearRect(0, 0, innerWidth, innerHeight); }
};
const kick = () => { if (!running) { running = true; requestAnimationFrame(loop); } };
return {
burst(x, y, n = 40) { if (reduce) return; ensure(); spawn(x, y, n, 1.2, 1); kick(); },
fly(from, to, dur = 750) {
return new Promise((res) => {
if (reduce) { res(); return; }
ensure();
const t0 = performance.now();
const cx = (from.x + to.x) / 2, cy = Math.min(from.y, to.y) - Math.max(120, Math.abs(from.x - to.x) * .35);
emitters.push((now) => {
const k = Math.min(1, (now - t0) / dur), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2, u = 1 - e;
const x = u * u * from.x + 2 * u * e * cx + e * e * to.x, y = u * u * from.y + 2 * u * e * cy + e * e * to.y;
for (let i = 0; i < 5; i++) parts.push({ x: x + (Math.random() - .5) * 6, y: y + (Math.random() - .5) * 6, vx: (Math.random() - .5) * .8, vy: -Math.random() * 1.2, life: 18 + Math.random() * 16, age: 0, size: 14 + Math.random() * 16 });
parts.push({ x, y, vx: 0, vy: 0, life: 4, age: 0, size: 38 });
if (k >= 1) { spawn(to.x, to.y, 36, 1, .6); res(); return false; }
});
kick();
});
}
};
})();
function initEmbers(host) {
if (reduce || !host) return;
const cv = document.createElement("canvas"); cv.className = "mw-embers"; cv.setAttribute("aria-hidden", "true");
host.prepend(cv);
const g = cv.getContext("2d");
let w = 0, h = 0, dpr = 1, on = true, running = false, list = [];
const size = () => { dpr = Math.min(devicePixelRatio, 2); w = host.clientWidth; h = host.clientHeight; cv.width = w * dpr; cv.height = h * dpr; };
new ResizeObserver(size).observe(host); size();
const max = matchMedia("(max-width: 760px)").matches ? 26 : 55;
const tick = () => {
if (!on) { running = false; return; }
requestAnimationFrame(tick);
if (list.length < max && Math.random() < .45) list.push({ x: Math.random() * w, y: h + 10, vy: -(.35 + Math.random() * .9), ph: Math.random() * 6.28, life: 220 + Math.random() * 260, age: 0, size: 2 + Math.random() * 4.5 });
g.setTransform(dpr, 0, 0, dpr, 0, 0); g.clearRect(0, 0, w, h); g.globalCompositeOperation = "lighter";
list = list.filter((p) => {
p.age++; p.ph += .03; p.x += Math.sin(p.ph) * .35; p.y += p.vy;
const k = p.age / p.life;
if (k >= 1 || p.y < -10) return false;
g.globalAlpha = Math.sin(Math.PI * k) * .9;
const s = p.size * 4; g.drawImage(FIRE.pick(k), p.x - s / 2, p.y - s / 2, s, s);
return true;
});
g.globalAlpha = 1;
};
new IntersectionObserver(([e]) => { on = e.isIntersecting; if (on && !running) { running = true; requestAnimationFrame(tick); } }).observe(host);
}
const ROOT = window.Shopify?.routes?.root || "/";
const money = (c) => { const v = c / 100; return (Number.isInteger(v) ? v : v.toFixed(2).replace(".", ",")) + " DT"; };
const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch]));
const center = (el) => { const r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; };
const Cart = (() => {
let el, list, foot;
const build = () => {
el = document.createElement("div"); el.className = "mw-cart"; el.hidden = true;
el.innerHTML = `<div class="mw-cart-scrim" data-mw-cart-close></div>
<aside class="mw-cart-panel" role="dialog" aria-modal="true" aria-label="Cart">
<header class="mw-cart-head"><h2>Cart <span data-mw-cart-n></span></h2><button class="mw-icon-btn" type="button" data-mw-cart-close aria-label="Close cart">✕</button></header>
<div class="mw-cart-items"></div>
<footer class="mw-cart-foot"><div class="mw-cart-sub"><span>Subtotal</span><b data-mw-cart-sub>0 DT</b></div>
<p>Cash on delivery · Free delivery across Tunisia</p>
<a class="mw-btn mw-btn--buy mw-btn--fire" href="${ROOT}checkout">Checkout</a>
<button class="mw-cart-continue" type="button" data-mw-cart-close>Continue shopping</button></footer>
</aside>`;
document.querySelector(".mw").appendChild(el);
list = el.querySelector(".mw-cart-items"); foot = el.querySelector(".mw-cart-foot");
el.addEventListener("click", (e) => {
if (e.target.closest("[data-mw-cart-close]")) { close(); return; }
const b = e.target.closest("[data-mw-line]");
if (b) change(b.dataset.key, Number(b.dataset.q));
});
document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !el.hidden) close(); });
};
const render = (cart) => {
const n = cart.item_count || 0;
document.querySelectorAll("[data-mw-cart-count]").forEach((c) => { c.textContent = n; c.hidden = !n; });
if (!el) return;
el.querySelector("[data-mw-cart-n]").textContent = n ? `(${n})` : "";
el.querySelector("[data-mw-cart-sub]").textContent = money(cart.total_price || 0);
foot.hidden = !n;
if (!n) { list.innerHTML = `<div class="mw-cart-empty"><p>Your cart is empty.</p><button class="mw-btn mw-btn--sm" type="button" data-mw-cart-close>View the shelf</button></div>`; return; }
list.innerHTML = cart.items.map((it) => {
const img = it.image ? it.image + (it.image.includes("?") ? "&" : "?") + "width=160" : "";
const k = esc(it.key), q = it.quantity;
return `<div class="mw-line">
${img ? `<img src="${esc(img)}" alt="" width="72" height="72" loading="lazy">` : `<span class="mw-line-ph"></span>`}
<div class="mw-line-info"><b>${esc(it.product_title)}</b>${it.variant_title ? `<small>${esc(it.variant_title)}</small>` : ""}
<div class="mw-qty mw-qty--sm"><button type="button" data-mw-line data-key="${k}" data-q="${q - 1}" aria-label="Decrease quantity">−</button><span>${q}</span><button type="button" data-mw-line data-key="${k}" data-q="${Math.min(20, q + 1)}" aria-label="Increase quantity">+</button></div></div>
<div class="mw-line-end"><span>${money(it.final_line_price)}</span><button class="mw-line-rm" type="button" data-mw-line data-key="${k}" data-q="0">Remove</button></div>
</div>`;
}).join("");
};
const refresh = () => fetch(ROOT + "cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json()).then(render).catch(() => {});
const change = (key, q) => {
list.classList.add("is-busy");
fetch(ROOT + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: Math.max(0, q) }) })
.then((r) => r.json()).then(render).catch(() => toast("Could not update the cart."))
.finally(() => list.classList.remove("is-busy"));
};
const open = () => {
if (!el) build();
refresh();
el.hidden = false;
requestAnimationFrame(() => el.classList.add("is-on"));
document.documentElement.style.overflow = "hidden";
el.querySelector(".mw-cart-head .mw-icon-btn").focus({ preventScroll: true });
};
const close = () => {
el.classList.remove("is-on");
document.documentElement.style.overflow = "";
setTimeout(() => { if (!el.classList.contains("is-on")) el.hidden = true; }, reduce ? 0 : 450);
};
const add = async (qty, btn) => {
const id = CFG.variantId;
if (!id) { toast("Preview: the cart works once the page is installed on Shopify."); return; }
const old = btn ? btn.innerHTML : "";
if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
const from = btn ? center(btn) : { x: innerWidth / 2, y: innerHeight / 2 };
fx.burst(from.x, from.y, 26);
try {
const r = await fetch(ROOT + "cart/add.js", {
method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
});
if (!r.ok) throw new Error((await r.json()).description || "Error");
if (!el) build();
const icon = document.querySelector(".mw-nav [data-mw-cart-open]");
await fx.fly(from, icon ? center(icon) : { x: innerWidth - 30, y: 30 });
await refresh();
if (icon) {
icon.classList.remove("is-hot"); void icon.offsetWidth; icon.classList.add("is-hot");
setTimeout(() => icon.classList.remove("is-hot"), 900);
}
setTimeout(open, reduce ? 0 : 280);
} catch (e) {
toast("Could not add to cart: " + e.message);
} finally {
if (btn) { btn.disabled = false; btn.innerHTML = old; }
}
};
return { open, add, refresh };
})();
const qtyIn = document.getElementById("mw-qty");
const qty = () => Math.max(1, Math.min(20, parseInt(qtyIn?.value, 10) || 1));
const orderForm = document.getElementById("mw-order");
const totalEl = document.querySelector("[data-mw-total]");
const updTotal = () => { if (totalEl && totalEl.dataset.unit) totalEl.textContent = money(Number(totalEl.dataset.unit) * qty()); };
document.querySelectorAll("[data-mw-step]").forEach((b) => b.addEventListener("click", () => setTimeout(updTotal, 0)));
qtyIn?.addEventListener("input", updTotal);
document.querySelectorAll("[data-mw-goto]").forEach((b) => b.addEventListener("click", () => { orderForm?.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" }); setTimeout(() => orderForm.querySelector("input")?.focus({ preventScroll: true }), 500); }));
document.querySelectorAll("[data-mw-cart-open]").forEach((b) => b.addEventListener("click", () => Cart.open()));
if (orderForm && !orderForm.elements.email) {
// optional email field, placed right after the phone number
const ph = orderForm.elements.phone?.closest(".mw-f");
if (ph) ph.insertAdjacentHTML("afterend", '<label class="mw-f"><span>Email <em>(optional)</em></span><input name="email" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" placeholder="you@example.com"></label>');
}
if (orderForm) {
const bar = document.querySelector(".mw-bar");
if (bar && "IntersectionObserver" in window) new IntersectionObserver(([e]) => bar.classList.toggle("is-hide", e.isIntersecting), { threshold: .15 }).observe(orderForm);
const err = orderForm.querySelector("[data-mw-err]");
const showErr = (m, el) => { err.textContent = m; err.hidden = !m; orderForm.querySelectorAll(".mw-f").forEach((f) => f.classList.remove("is-bad")); if (el) { el.closest(".mw-f").classList.add("is-bad"); el.focus(); } };
orderForm.addEventListener("submit", async (e) => {
e.preventDefault();
const f = orderForm.elements, btn = orderForm.querySelector("[data-mw-order]");
const name = f.name.value.trim(), phone = f.phone.value.replace(/[\s.\-()]/g, "").replace(/^(\+216|00216)/, ""), gov = f.gov.value, city = f.city.value.trim(), addr = f.addr.value.trim(); const car = (f.car?.value || "").trim().slice(0, 60); const email = (f.email?.value || "").trim().slice(0, 120);
if (name.length < 3) return showErr("Please enter your full name.", f.name);
if (!/^\d{8}$/.test(phone)) return showErr("Enter a valid 8-digit phone number.", f.phone);
if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return showErr("Enter a valid email, or leave it empty.", f.email);
if (!gov) return showErr("Choose your governorate.", f.gov);
if (city.length < 2) return showErr("Enter your city or area.", f.city);
if (addr.length < 5) return showErr("Enter your address.", f.addr);
if (!CFG.variantId) { showErr("Preview: ordering works once the page is installed on Shopify."); return; }
showErr("");
btn.disabled = true; btn.textContent = "Sending…";
try {
const post = (u, b) => fetch(ROOT + u, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(b) });
await post("cart/clear.js", {});
const r = await post("cart/add.js", { items: [{ id: Number(CFG.variantId), quantity: qty() }] });
if (!r.ok) throw new Error("add");
await post("cart/update.js", { note: "COD order · " + name + " · " + phone + " · " + gov + ", " + city + " · " + addr + (car ? " · Favorite car: " + car : "") + (email ? " · " + email : ""), attributes: { Phone: phone, Email: email, Governorate: gov, City: city, Address: addr, "Favorite car": car } });
// InitiateCheckout is sent by the Shopify Meta channel
const parts = name.split(/\s+/), first = parts.shift(), last = parts.join(" ") || first;
const q = new URLSearchParams({ "checkout[shipping_address][first_name]": first, "checkout[shipping_address][last_name]": last, "checkout[shipping_address][address1]": addr, "checkout[shipping_address][city]": city + " - " + gov, "checkout[shipping_address][country]": "Tunisia", "checkout[shipping_address][phone]": phone });
if (email) q.set("checkout[email]", email);
location.href = ROOT + "checkout?" + q.toString();
} catch (x) {
btn.disabled = false; btn.textContent = "Confirm order";
showErr("Something went wrong. Please try again or message us on WhatsApp.");
}
});
}
if (CFG.variantId) Cart.refresh();
initEmbers(document.querySelector(".mw-product"));